var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFleche250(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 192,
    viewBox: "0 0 7 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_34",
    "data-name": "Groupe 34",
    transform: "translate(-1079.5 -487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M5133.166-603.638v-180",
    transform: "translate(-4050.166 1276.638)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3",
    "data-name": "Polygone 3",
    d: "M3.5,0,7,6H0Z",
    transform: "translate(1086.5 679) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_4",
    "data-name": "Polygone 4",
    d: "M3.5,0,7,6H0Z",
    transform: "translate(1079.5 487)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleche250);
export default __webpack_public_path__ + "static/media/fleche-250.c44f585ab8832de0aaf8992c82d7ac7e.svg";
export { ForwardRef as ReactComponent };